import React from 'react';

import { useIsSuspended } from '@cherre-frontend/data-fetching';
import { ValidationParametersPanel } from '../components/ValidationParametersPanel';

import { EmptyState, FileSettingsIcon } from '@cherre-frontend/ui';

export const DatasetValidationParametersPanel = () => {
  const suspended = useIsSuspended();
  const validations = [];

  return (
    <ValidationParametersPanel>
      {validations.length && !suspended ? (
        <></>
      ) : (
        <EmptyState
          title='No Dataset Validations'
          subtitle='There are currently no dataset validations that require validation parameters.'
          Icon={FileSettingsIcon}
        />
      )}
    </ValidationParametersPanel>
  );
};
